import { cx } from "@/utils";

export default function ProgressBar({ className, progress }) {
  return (
    <div
      className={cx(
        className,
        "bg-cp-primary-200/20 h-2.5 w-full rounded-[50px]",
      )}
    >
      <div
        className="bg-cp-primary-200 h-2.5 rounded-[50px]"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
}
